module.exports = __webpack_public_path__ + "img/example-garage-kiosk-arrows.d8082185.webp";